import { render } from "./ReportCreateContentElement.vue?vue&type=template&id=68cfa07a&scoped=true"
import script from "./ReportCreateContentElement.vue?vue&type=script&lang=js"
export * from "./ReportCreateContentElement.vue?vue&type=script&lang=js"

import "./ReportCreateContentElement.vue?vue&type=style&index=0&id=68cfa07a&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cfa07a"]])

export default __exports__